// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"index-module--mainLayout--3Qpp_","mainContent":"index-module--mainContent--1EPOL"};